import * as SCRAP_API from '@/api/qualityData'

export default {
  state: {
    bomScraps: [],
    partScraps: []
  },
  getters: {
    bomScraps: state => {
      return state.bomScraps
    },
    partScraps: state => {
      return state.partScraps
    }
  },
  mutations: {
    setBomScraps (state, bomScrap) {
      state.bomScraps = _.concat(state.bomScraps, bomScrap)
    },
    setPartScraps(state, partScrap) {
      state.partScraps = _.concat(state.partScraps, partScrap)
    }
  },
  actions: {
    getBomScraps({ commit, state }, bomId) {
      return SCRAP_API.getBomScrap(bomId).then(resp => {
        commit('setBomScraps', resp.data)
        return resp.data
      })
    },
    setBomScrap({ commit, state }, { bomId, data }) {
      return SCRAP_API.setBomScrap(bomId, data).then(resp => {
        return resp.data
      })
    },
    getPartScraps({ commit, state }, manufacturerPartIds) {
      return SCRAP_API.getPartScraps(manufacturerPartIds).then(resp => {
        commit('setPartScraps', resp.data)
        return resp.data
      })
    },
    setPartScrap({ commit, state }, { partId, data }) {
      return SCRAP_API.setPartScrap(partId, data).then(resp => {
        return resp.data
      })
    },
    getQualityDataList({ commit, state }, { modelType, data }) {
      return SCRAP_API.getQualityDataList(modelType, data).then(resp => {
        return resp.data
      })
    },
    updateDefaultScrap({ commit, state }, bomId) {
      return SCRAP_API.updateDefaultScrap(bomId).then(resp => {
        return resp.data
      })
    }
  }
}
